/**
 * Un solo service worker per il CRM.
 *
 * Storia breve: le notifiche registravano /sw-push.js sullo stesso indirizzo di
 * base ("/") del service worker degli aggiornamenti. Due service worker sullo
 * stesso ambito non convivono, il secondo scalza il primo. Chi accendeva le
 * notifiche perdeva quello degli aggiornamenti: il pulsante "Ricarica" non
 * aveva piu' nessuno a cui parlare e il CRM restava fermo alla versione di quel
 * giorno, senza che nessuno se ne accorgesse.
 *
 * Ora i listener delle notifiche stanno dentro il service worker generato da
 * Workbox (importScripts in vite.config.ts) e di registrazioni ne esiste una
 * sola. Su un browser che porta ancora la vecchia registrazione, pero', quella
 * continuerebbe a fare danni finche' qualcuno non la toglie: e' il compito di
 * questa funzione, che va chiamata all'avvio dell'app.
 */

/** Rimuove la vecchia registrazione autonoma di sw-push.js, se c'e' ancora. */
export async function rimuoviVecchioServiceWorkerPush(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return false;

  try {
    const registrazioni = await navigator.serviceWorker.getRegistrations();
    let rimossa = false;

    for (const registrazione of registrazioni) {
      const script =
        registrazione.active?.scriptURL ||
        registrazione.waiting?.scriptURL ||
        registrazione.installing?.scriptURL ||
        '';
      if (!script.endsWith('/sw-push.js')) continue;

      // L'iscrizione appesa alla vecchia registrazione va chiusa: lasciarla
      // viva significherebbe la stessa notifica consegnata due volte allo
      // stesso browser, una per registrazione.
      const vecchiaIscrizione = await registrazione.pushManager.getSubscription().catch(() => null);
      if (vecchiaIscrizione) await vecchiaIscrizione.unsubscribe().catch(() => undefined);

      await registrazione.unregister();
      rimossa = true;
      console.info('[serviceWorker] rimossa la vecchia registrazione di sw-push.js');
    }

    return rimossa;
  } catch (error) {
    // Se la pulizia non riesce non si blocca nulla: al massimo resta com'era.
    console.warn('[serviceWorker] pulizia della vecchia registrazione non riuscita', error);
    return false;
  }
}
